<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title">Забыли вароль?</h4>
            </div>
            <div class="modal-body">
                <p>Укажите email для восстановления пароля.</p>
                <input type="text" v-model="restore_email" name="email" placeholder="Email" autocomplete="off" class="form-control placeholder-no-fix">
            </div>
            <div class="modal-footer">
                <button data-dismiss="modal" class="btn btn-default" type="button">Отмена</button>
                <button class="btn btn-success" type="button">Отправить</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    restore_email: '',
  }),
  methods: {
    restore_password(event) {
      // let last_token = Vue.localStorage.get('access_token');
      axios.post('/api/restore_password', {
        restore_email: this.restore_email,
      })
        .then((response) => {
          if (response.data.success === false) {
            alert('Неправильный email или пароль. Или все вместе.');
          } else {
            alert('');
          }
        })
        .catch((e) => {
          alert('Ошибка!');
          // console.log(e);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login/LoginRestoreComponent.vue